/*
 * nadi-store-rating.js — put the store's rating where it changes a decision.
 *
 * WHY. Benchmarked against plateful.co on 2026-08-11: their product page runs
 * rating -> h1 -> add to cart, in that order, and they show it with FOUR
 * reviews. This store has 5.0 from 253 Google reviews and shows it on no
 * product page at all. 48,335 sessions a quarter land on a product page and
 * convert at 0.49%; the strongest social proof the business owns is not on
 * any of them.
 *
 * ── WHAT IT IS CAREFUL NOT TO CLAIM ───────────────────────────────────────
 * This is a STORE rating, not a product rating. Ryviu holds zero product
 * reviews. Presenting a store score as if it belonged to the product would
 * mislead the customer and breach Google's structured data policy, so:
 *
 *   - the label always reads "ביקורות על החנות בגוגל", in full, never "reviews"
 *   - no aggregateRating is emitted; nadi-product-jsonld stays clean
 *   - the figures live in one constant below and nowhere else
 *
 * ── THE FIGURES ARE MANUAL, ON PURPOSE ────────────────────────────────────
 * The Google widget is a third-party embed that does not render on product
 * pages, so there is nothing to read at runtime. Hard-coding is the honest
 * option, but it drifts: 253 was correct in August 2026. Whoever raises it
 * should change RATING below and nothing else.
 */
(function () {
  'use strict';

  var RATING = { score: '5.0', count: 253,
                 href: 'https://www.google.com/search?q=nadi+store+%D7%A2%D7%95%D7%9E%D7%A8' };

  function build() {
    var el = document.createElement('div');
    el.className = 'nadi-rating';
    el.setAttribute('data-nadi-rating', '');
    el.innerHTML =
      '<span class="nadi-rating__stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>' +
      '<span class="nadi-rating__score">' + RATING.score + '</span>' +
      '<span class="nadi-rating__count">' +
        '<a href="' + RATING.href + '" target="_blank" rel="noopener nofollow">' +
        RATING.count + ' ביקורות על החנות בגוגל</a>' +
      '</span>';
    return el;
  }

  function run() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('[data-nadi-rating]')) return;

    /* Above the title, matching the benchmark — but only inside the product
       form column. A bare h1 lookup would also match a heading in a
       recommendations block or a page section, and the badge would land
       somewhere meaningless. */
    var scope = document.querySelector('.t4s-product__info-wrapper, .t4s-product-info, .t4s-product__info');
    var h1 = scope ? scope.querySelector('h1') : document.querySelector('.t4s-product__title, h1.t4s-product__title');
    if (!h1) h1 = document.querySelector('h1');
    if (!h1 || !h1.parentNode) return;

    h1.parentNode.insertBefore(build(), h1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
